/* eslint prefer-destructuring: 0 */
import React, { useState, useEffect } from 'react';
import FormFieldDrop from '../formField/drop';
import GenericField from '../formField/genericField';
import FormRow from '../formRow';
import * as personService from '../../services/person';
import LoadScreen from '../../view/load';
import LabelField from '../formField/label';
import { successNotification } from '../notification';
import './styles.css';

const Person = ({
  person,
  setPerson,
  cpfCnpj,
  setCpfCpnj,
  address,
  setAddress,
  addresses,
  setAddresses,
  contact,
  setContact,
  contacts,
  setContacts,
  afterClientSelection,
  searchType = 'C',
  hasContact = true,
  disabled
}) => {
  const [phone, setPhone] = useState('');
  const [cellPhone, setCellPhone] = useState('');
  const [loadingDiv, setLoadingDiv] = useState(false);

  const updateClientDetails = async (client, address, contact) => {
    let newAddress = address;
    let newContact = null;
    if (client != null) {
      setCpfCpnj('');
      setPhone('');
      setCellPhone('');
      setAddress(null);
      if (client.TipoPessoa === 0) {
        setCpfCpnj(client.CPF);
        setAddress(client.Endereco);
        newAddress = client.Endereco;
        setPhone(client.Telefone?.Numero);
        setCellPhone(client.Celular?.Numero);
        newContact = { Nome: null, Email: client.Email };
        setContact(contact);
        setContacts(null);
      } else {
        newContact = { Nome: null, Email: client.Email };
        setContact(contact);
        let addresses = [];
        if (client.EnderecoPrincipal != null) addresses.push(client.EnderecoPrincipal);
        addresses = addresses.concat(client.OutrosEnderecos);
        addresses = addresses.map((item) => ({
          ...item,
          EnderecoCompleto: [item.Logradouro, item.Numero, item.Complemento, item.Bairro]
            .filter(Boolean)
            .join(', ')
        }));
        if (newAddress != null) {
          const telefone = newAddress.Telefones?.find((x) => x.Descricao === 'Telefone');
          const celular = newAddress.Telefones?.find((x) => x.Descricao === 'Celular');
          setPhone(telefone?.Numero);
          setCellPhone(celular?.Numero);
          setCpfCpnj(newAddress.CNPJ ? newAddress.CNPJ : '');
          setAddress(newAddress);
        } else if (addresses.length === 1) {
          const telefone = addresses[0].Telefones?.find((x) => x.Descricao === 'Telefone');
          const celular = addresses[0].Telefones?.find((x) => x.Descricao === 'Celular');
          setPhone(telefone?.Numero);
          setCellPhone(celular?.Numero);
          setCpfCpnj(addresses[0].CNPJ ? addresses[0].CNPJ : '');
          setAddress(addresses[0]);
          newAddress = addresses[0];
        }
        setAddresses(addresses);
        const contacts = [];
        if (client.Contatos?.length > 0) {
          client.Contatos.forEach((item) => {
            contacts.push(item);
          });
        }
        if (addresses?.length > 0) {
          addresses.forEach((item1) => {
            if (item1.Contatos?.length > 0) {
              item1.Contatos.forEach((item2) => {
                contacts.push(item2);
              });
            }
          });
        }
        contacts.sort();
        if (!contacts) {
          newContact = { Nome: null, Email: client.Email };
          setContact(newContact);
          setContacts(null);
        } else if (contacts.length > 0) {
          const contato = contacts.find((x) => x.Id === contact?.Id);
          if (contato) {
            setContact(contato);
            newContact = contato;
          }
          contacts.sort((a, b) => {
            if (a.Nome < b.Nome) {
              return -1;
            }
            if (a.Nome > b.Nome) {
              return 1;
            }
            return 0;
          });
          setContacts(contacts);
        }
      }
      return {
        address: newAddress,
        contact: newContact
      };
    }
    setCpfCpnj('');
    setPhone('');
    setCellPhone('');
    setAddress(null);
    setAddresses([]);
    setContact(null);
    setContacts(null);
    return null;
  };

  const loadClient = async (client) => {
    setLoadingDiv(true);
    setPerson(client);
    const addressContact = await updateClientDetails(client, null, null);
    if (afterClientSelection)
      afterClientSelection(client, addressContact.address, addressContact.contact);
    setLoadingDiv(false);
  };

  const loadClients = async (filter) => {
    let response = null;
    if (searchType === 'C') response = await personService.getByClientName(filter);
    else if (searchType === 'F') response = await personService.getBySupplierName(filter);
    else if (searchType === 'E') response = await personService.getByCollaboratorName(filter);
    else response = await personService.getByName(filter);
    const { data } = response;
    return data;
  };

  useEffect(async () => {
    await updateClientDetails(person, address, contact);
  }, []);

  return (
    <div>
      {loadingDiv ? (
        <LoadScreen />
      ) : (
        <>
          <FormRow withShrink>
            <div className="fill-66-field-margin">
              <FormFieldDrop
                titleLabel="Nome"
                defaultValueSelect="Procure por nome..."
                onChangeValue={async (val) => {
                  if (val.value) {
                    await loadClient(val.value);
                  } else {
                    setPerson(null);
                    updateClientDetails(null);
                    if (afterClientSelection) afterClientSelection(null, null, null);
                  }
                }}
                value={person}
                className="fill-100-field"
                loadData={loadClients}
                serverFiltering={true}
                dataItemKey="Id"
                textField="Nome"
                required
                disabled={disabled}
              />
            </div>
            <div className="fill-33-field-margin">
              <GenericField
                titleLabel={person?.TipoPessoa !== 0 ? 'CNPJ' : 'CPF'}
                value={cpfCnpj}
                classNameWrapper="fill-100-field"
                disabled
              />
            </div>
          </FormRow>

          {person != null && person.TipoPessoa !== 0 && (
            <FormRow withShrink>
              <FormFieldDrop
                titleLabel="Matriz/Filial"
                defaultValueSelect="Selecione..."
                onChangeValue={(val) => {
                  if (val.value) {
                    updateClientDetails(person, val.value);
                    if (afterClientSelection) afterClientSelection(person, val.value, null);
                  }
                }}
                value={address}
                className="fill-100-field"
                infosSelect={addresses}
                dataItemKey="Id"
                textField="EnderecoCompleto"
                disabled={disabled}
              />
            </FormRow>
          )}

          <FormRow>
            <div className="fill-33-field-margin">
              <FormRow withoutMarginTop>
                <GenericField
                  titleLabel="Rua/Avenida"
                  value={address?.Logradouro}
                  classNameWrapper="fill-70-field"
                  disabled
                />
                <GenericField
                  titleLabel="Numero"
                  value={address?.Numero}
                  classNameWrapper="fill-30-field"
                  disabled
                />
              </FormRow>
            </div>
            <div className="fill-33-field-margin">
              <FormRow withoutMarginTop>
                <GenericField
                  titleLabel="Complemento"
                  value={address?.Complemento}
                  classNameWrapper="fill-30-field"
                  disabled
                />
                <GenericField
                  titleLabel="Bairro"
                  value={address?.Bairro}
                  classNameWrapper="fill-70-field"
                  disabled
                />
              </FormRow>
            </div>
            <div className="fill-33-field-margin">
              <FormRow withoutMarginTop>
                <GenericField
                  titleLabel="Cidade"
                  value={
                    address?.MunicipioNaoCadastrado
                      ? address?.MunicipioNaoCadastrado
                      : address?.Municipio?.nomeMunicipio
                  }
                  classNameWrapper={
                    address?.MunicipioNaoCadastrado ? 'fill-50-field' : 'fill-60-field'
                  }
                  disabled
                />
                <GenericField
                  titleLabel={address?.EstadoNaoCadastrado ? 'Estado' : 'UF'}
                  value={
                    address?.EstadoNaoCadastrado
                      ? address?.EstadoNaoCadastrado
                      : address?.Municipio?.siglaEstado
                  }
                  classNameWrapper={
                    address?.EstadoNaoCadastrado ? 'fill-50-field' : 'fill-40-field'
                  }
                  disabled
                />
              </FormRow>
            </div>
          </FormRow>
          <FormRow>
            <GenericField
              titleLabel="País"
              value={address?.NomePais}
              classNameWrapper="fill-24-field"
              disabled
            />
            <LabelField
              titleLabel="Telefone"
              classNameWrapper="fill-24-field"
              valueLabel={
                phone ? (
                  <a
                    className="link-left"
                    href={`https://api.whatsapp.com/send?phone=${phone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {phone}
                  </a>
                ) : (
                  '-'
                )
              }
              enableIcon
              classNameIcon="config-icon-copy"
              titleIcon="Copiar"
              onClickIcon={() => {
                navigator.clipboard.writeText(!phone ? '' : phone);
                successNotification('Telefone copiado!');
              }}
            />
            <LabelField
              titleLabel="Celular"
              classNameWrapper="fill-24-field"
              valueLabel={
                cellPhone ? (
                  <a
                    className="link-left"
                    href={`https://api.whatsapp.com/send?phone=${cellPhone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {cellPhone}
                  </a>
                ) : (
                  '-'
                )
              }
              enableIcon
              classNameIcon="config-icon-copy"
              titleIcon="Copiar"
              onClickIcon={() => {
                navigator.clipboard.writeText(!cellPhone ? '' : cellPhone);
                successNotification('Celular copiado!');
              }}
            />

            <LabelField
              titleLabel="E-mail"
              classNameWrapper="fill-24-field"
              valueLabel={
                person?.Email ? (
                  <a
                    className="link-left"
                    href={`mailto:${person?.Email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {person?.Email}
                  </a>
                ) : (
                  '-'
                )
              }
              enableIcon
              classNameIcon="config-icon-copy"
              titleIcon="Copiar"
              onClickIcon={() => {
                navigator.clipboard.writeText(person?.Email ? person?.Email : '');
                successNotification('E-mail copiado!');
              }}
            />
          </FormRow>
          {hasContact && contacts ? (
            <FormRow>
              <FormFieldDrop
                titleLabel="Contato"
                defaultValueSelect="Selecione..."
                value={contact}
                onChangeValue={(val) => {
                  setContact(val.value);
                  if (afterClientSelection) afterClientSelection(person, address, val.value);
                }}
                className="fill-24-field"
                infosSelect={contacts}
                dataItemKey="Id"
                textField="Nome"
                disabled={disabled}
              />
              <LabelField
                titleLabel="Telefone"
                classNameWrapper="fill-24-field"
                valueLabel={
                  contact?.Telefone?.Numero ? (
                    <a
                      className="link-left"
                      href={`https://api.whatsapp.com/send?phone=${contact?.Telefone?.Numero}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {contact?.Telefone?.Numero}
                    </a>
                  ) : (
                    '-'
                  )
                }
                enableIcon
                classNameIcon="config-icon-copy"
                titleIcon="Copiar"
                onClickIcon={() => {
                  navigator.clipboard.writeText(
                    contact?.Telefone?.Numero ? contact?.Telefone?.Numero : ''
                  );
                  successNotification('Telefone copiado!');
                }}
              />

              <LabelField
                titleLabel="Celular"
                classNameWrapper="fill-24-field"
                valueLabel={
                  contact?.Celular?.Numero ? (
                    <a
                      className="link-left"
                      href={`https://api.whatsapp.com/send?phone=${contact?.Celular?.Numero}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {contact?.Celular?.Numero}
                    </a>
                  ) : (
                    '-'
                  )
                }
                enableIcon
                classNameIcon="config-icon-copy"
                titleIcon="Copiar"
                onClickIcon={() => {
                  navigator.clipboard.writeText(
                    contact?.Celular?.Numero ? contact?.Celular?.Numero : ''
                  );
                  successNotification('Celular copiado!');
                }}
              />
              <LabelField
                titleLabel="E-mail"
                classNameWrapper="fill-24-field"
                valueLabel={
                  contact?.Email ? (
                    <a
                      className="link-left"
                      href={`mailto:${contact?.Email}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {contact?.Email}
                    </a>
                  ) : (
                    '-'
                  )
                }
                enableIcon
                classNameIcon="config-icon-copy"
                titleIcon="Copiar"
                onClickIcon={() => {
                  navigator.clipboard.writeText(contact?.Email ? contact?.Email : '');
                  successNotification('E-mail copiado!');
                }}
              />
            </FormRow>
          ) : (
            <>
              {hasContact && (
                <FormRow>
                  <GenericField
                    titleLabel="Contato"
                    onChangeValue={(val) => {
                      setContact({ Nome: val.value });
                    }}
                    value={contact?.Nome}
                    classNameWrapper="fill-50-field"
                    disabled={disabled}
                  />
                </FormRow>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Person;
